import { createAction, props } from '@ngrx/store';
import { VerifyDecedentResponse } from '@shared/services/verify-decedent/verify-decedent.service';

export const verifyDecedentStart = createAction(
  '[Decedent Info Page] Starting Verify Decedent Call',
);
export const verifyDecedentEnd = createAction(
  '[Client Search API] Search Complete',
  props<{ payload: VerifyDecedentResponse }>(),
);

export const clientSearchError = createAction('[Client Search API] Client Search API Error');
